import * as actionTypes from "./../../actionTypes";
import { apiAdminUrl, apiBaseUrl, WebDomain } from "./../../common";
import swal from "sweetalert";
import AuthService from './../../services/authService'

const handleResponse = (response) => {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401 || response.status === 400) {
                swal({
                    title: "Expired!",
                    text: "Your session is expired!",
                    icon: "error" 
                }) 
                localStorage.removeItem("token");
                window.location.href =`https://${WebDomain}`;
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
};

export const MeetingSettings = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.MEETINGS_SETTINGS, payload: data });
    };
};

export const InviteViaMail = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiAdminUrl}/userPanel/invite-user`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: data.ResponseText,
                        icon: "success",
                    });
                    return 1;
                }else{
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                swal({
                    title: "Error!",
                    text: "Failed to send mail",
                    icon: "error",
                });
                return 0;
            });
    };
};

export const SentMailList = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        // dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}userPanel/meeting-users-emailCount`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                // dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    return {code:1,response:data.data};
                }else{
                    // swal({
                    //     title: "Error!",
                    //     text: data.ResponseText,
                    //     icon: "error",
                    // });
                    
                    return {code:0};
                }
            })
            .catch(() => {
                // dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                
                swal({
                    title: "Error!",
                    text: "Failed to send mail",
                    icon: "error",
                });
                return {code:0};
            });
    };
}

export const AddParticipantsMeet = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}userPanel/add-participants`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: data.ResponseText,
                        icon: "success",
                    });
                    return 1;
                }else{
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch(() => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                swal({
                    title: "Error!",
                    text: "Failed to send mail",
                    icon: "error",
                });
                return 0;
            });
    };
}

export const SentInvitationList = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}userPanel/invited-participants-list`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({ type: actionTypes.INVITATION_LIST, payload: data.data });
                    return {code:1,response:data.data};
                }else{
                    dispatch({ type: actionTypes.INVITATION_LIST, payload: [] });
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return {code:0};
                }
            });
    };
}

export const UpdateTopic = (params) => { 
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiAdminUrl}userPanel/update-topic`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    return 1;
                }else{
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                return 0
            });
    };
};